import { api } from '@/boot/axios'

class IntegrationService {
  constructor() {
    // no-op
  }

  // JustTCG config
  getJustTCGConfig() {
    return api.get('/integrations/justtcg/config')
  }

  updateJustTCGConfig(payload) {
    return api.put('/integrations/justtcg/config', payload)
  }

  // JustTCG card proxy
  justtcgSearch(params = {}) {
    return api.get('/integrations/justtcg/cards', { params })
  }

  justtcgBatch(items = []) {
    return api.post('/integrations/justtcg/cards', { data: items })
  }

  // Astro config
  getAstroConfig() {
    return api.get('/integrations/astro/config')
  }

  updateAstroConfig(payload) {
    return api.put('/integrations/astro/config', payload)
  }

  testAstroToken() {
    return api.post('/integrations/astro/test/token')
  }

  getAstroStatus() {
    return api.get('/integrations/astro/status')
  }

  // Astro admin helpers
  triggerAstroEligibleSync() {
    return api.post('/astro/admin/eligible-sync')
  }

  listAstroEligibleItems() {
    return api.get('/astro/admin/eligible-items')
  }

  listAstroLogs(params = {}) {
    return api.get('/astro/admin/logs', { params })
  }

  // Astro location mapping
  getAstroLocationMap() {
    return api.get('/integrations/astro/location-map')
  }

  updateAstroLocationMap(rows) {
    return api.put('/integrations/astro/location-map', { rows })
  }

  // Astro customer link/unlink
  getAstroCustomerMap(ids = []) {
    const params = ids && ids.length ? { ids } : {}
    return api.get('/integrations/astro/customers/map', { params })
  }

  linkAstroCustomer(blu_customer_id, astro_customer_id) {
    return api.post('/integrations/astro/customers/link', { blu_customer_id, astro_customer_id })
  }

  unlinkAstroCustomer(blu_customer_id) {
    return api.post('/integrations/astro/customers/unlink', { blu_customer_id })
  }

  // Astro helper: customer status (for URLs, etc.)
  customerStatus(customerId) {
    return api.post('/astro/customer/status', { customer_id: customerId })
  }

  // Astro offers/coupons/points
  listOffers() {
    return api.get('/astro/offers')
  }

  addOfferTransaction(payload) {
    return api.post('/astro/offers/transaction', payload)
  }

  removeOfferTransaction(payload) {
    return api.post('/astro/offers/transaction/remove', payload)
  }

  addOfferRedemption(payload) {
    return api.post('/astro/offers/redemption', payload)
  }

  addOfferRedemptionOnly(payload) {
    return api.post('/astro/offers/redemption-only', payload)
  }

  redeemCoupon(customer_id, coupon_code, astro_item_id) {
    return api.post('/astro/coupons/redeem', { customer_id, coupon_code, astro_item_id })
  }

  removeCoupon(customer_id, coupon_code) {
    return api.post('/astro/coupons/remove', { customer_id, coupon_code })
  }

  pointsStatus(customer_id) {
    return api.post('/astro/points/status', { customer_id })
  }

  addPointsByDollar(customer_id, dollar_amount) {
    return api.post('/astro/points/add-dollar', { customer_id, dollar_amount })
  }

  addPoints(customer_id, total_points) {
    return api.post('/astro/points/add', { customer_id, total_points })
  }

  redeemPoints(customer_id, astro_points_reward_id) {
    return api.post('/astro/points/redeem', { customer_id, astro_points_reward_id })
  }

  // Astro redemption (frequent buyer)
  checkRedemption(customer_id, item_code) {
    return api.post('/astro/redemption/check', { customer_id, item_code })
  }
  addRedemption(payload) {
    // payload: { customer_id, astro_reward_id, astro_item_id, ...optional address fields }
    return api.post('/astro/redemption/add', payload)
  }
  removeRedemption(customer_id, astro_reward_id) {
    return api.post('/astro/redemption/remove', { customer_id, astro_reward_id })
  }
}

export default new IntegrationService()


